module.exports = __webpack_public_path__ + "img/weatherBc1.1630993415105.jpg";